import { ReactNode } from "react";
import { LeafletMap } from "../LeafletMap/Index";
import { ICoord } from "../../../@types/GoogleMaps/ICoord";

type LeafletStaticMapProps = {
  children: ReactNode;
  center?: ICoord;
};

export function LeafletStaticMap({ children, center }: LeafletStaticMapProps) {
  const interactionOptions = {
    zoomControl: false,
    doubleClickZoom: false,
    closePopupOnClick: false,
    dragging: false,
    trackResize: false,
    touchZoom: false,
    scrollWheelZoom: false,
  };
  return <LeafletMap interactionOptions={interactionOptions} center={center}>{children}</LeafletMap>;
}
